﻿window.initSendSafely = (componentId) => {
  self = this;
  let $dropzone = window.jQuery(`#${componentId}`),
    dropzoneId = $dropzone.data("dropzone-id"),
    valueId = $dropzone.data("value-id"),
    formField = $("#" + valueId),
    form = $dropzone.closest("form");

  const widget = new window.SendSafelyDropzone(dropzoneId, $dropzone);
  widget.disableAutoSubmit = true;
  widget.initialize();

  form[0].setAttribute("onsubmit", "");

  form[0].addEventListener("submit", function (e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    if (!widget.nbrOfFilesAttached > 0) {
      window.kentico.updatableFormHelper.submitForm(e);
    }
    widget.finalizePackage(
      function (url) {
        formField.val(url);
        window.kentico.updatableFormHelper.submitForm(e);
      },
      function (message) {
        console.log(message);
      }
    );
  });
};
